class BackToTop extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.showAfter = Number(this.dataset.showAfter) || 0;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.ticking = false;

    this.onScroll = this.onScroll.bind(this);
    this.scrollToTop = this.scrollToTop.bind(this);

    this.button?.addEventListener('click', this.scrollToTop);
    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.updateVisibility();
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.scrollToTop);
    window.removeEventListener('scroll', this.onScroll);
  }

  onScroll() {
    if (this.ticking) return;

    this.ticking = true;
    requestAnimationFrame(() => {
      this.updateVisibility();
      this.ticking = false;
    });
  }

  updateVisibility() {
    this.classList.toggle('is-visible', window.scrollY >= this.showAfter);
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: this.reducedMotion.matches ? 'auto' : 'smooth',
    });
  }
}

if (!customElements.get('back-to-top')) customElements.define('back-to-top', BackToTop);
